import React from 'react'
import styled from 'styled-components'
import { device } from '@styles/global/breakpoints'

interface IProps {
  text: string
}

function VerticalCategory ({ text }: IProps) {
  return (
    <Category>
      <Name>
        {text}
      </Name>
      <Line/>
    </Category>
  )
}

const Name = styled.div`
    position: absolute;
    transform: translateX(-50%) rotate(180deg);
    transform-origin: center;
    writing-mode: vertical-rl;
    top: 0;
    left: 50%;
    font-size: 24px;
    padding-top: 20px;
    z-index: 2;
    text-transform: uppercase;
`
const Line = styled.div`
  width: 1px;
  height: 100%;
  position: absolute;
  bottom: 0;
  left: 50%;
`
const Category = styled.div`
  position: absolute;
  top: 0;
  height: 100%;
  left: 20px;
  @media ${device.tablet}{
    position: relative;
    grid-column: 2;
    grid-row: 1 / 4;
    left: 0;
  }
  
  ${Name}{
    color: ${props => props.theme.textColor};
    background: ${props => props.theme.backgroundPrimary};
  }
  ${Line}{
    background: ${props => props.theme.lineColor};
  }
`

export default VerticalCategory